import { render, staticRenderFns } from "./updateFeatures.vue?vue&type=template&id=11cceeab&"
import script from "./updateFeatures.vue?vue&type=script&lang=js&"
export * from "./updateFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/xampp/htdocs/riiqo-website-2020/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
